import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import { verifySubscriber } from './auth/Auth.hooks';
import {
	AUTH_KEY,
	AUTH_SUBJECT_KEY,
} from '../../views/home/auth/Authentication.hooks';

export function useCallback(): CallbackResponse {
	const [searchParams] = useSearchParams();
	const [isActive, setIsActive] = useState<null | boolean>(null);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [error, setError] = useState<Error | null>(null);
	const token = searchParams.get('id_token');
	useEffect(() => {
		if (!token) {
			setError(new Error('The token must be send'));
			setIsLoading(false);
			return;
		}

		let decoded: { sub: string; exp: number } | null = null;
		try {
			decoded = jwtDecode(token);
		} catch (e) {
			setError(new Error('Invalid Token'));
			return;
		}

		if (!decoded) {
			return;
		}

		const { sub, exp } = decoded;
		const expirationDate = new Date(exp * 1000);
		verifySubscriber(sub)
			.then((active) => {
				if (active) {
					localStorage.setItem(AUTH_KEY, 'true');
					localStorage.setItem(AUTH_SUBJECT_KEY, sub);
				}
				setIsLoading(false);
				setIsActive(active);
			})
			.catch(() => {
				setIsLoading(false);
				setError(new Error('Error verifying user'));
			});
		console.log({
			sub,
			expirationDate,
		});
	}, [token]);
	return {
		isLoading,
		error,
		isActive,
	};
}

interface CallbackResponse {
	isLoading: boolean;
	error: Error | null;
	isActive: null | boolean;
}
